// extracted by mini-css-extract-plugin
export var aircallIframe = "_co-3";
export var fabContainer = "_co-5";
export var fabRinging = "_co-6";
export var loadingOverlay = "_co-4";
export var pulse = "_co-7";
export var widgetContent = "_co-2";
export var widgetPanel = "_co-0";
export var widgetPanelExpanded = "_co-1";